import React from 'react';
import {Text, useColorModeValue} from '@chakra-ui/react';

// Shared "soft neutral" metadata pill.
//
// Generalized from the Planner schedule row's pill so the schedule and
// the patient-history cards speak one visual language: a calm, bordered
// pill that reserves color for the card's modality stripe and opalite
// accents rather than the metadata itself.
//
// Defaults match the schedule's `scheduleStyles` (gray.100 fill, gray.200
// border, gray.700 text) so re-pointing the schedule at this component is
// a pixel-identical refactor. Callers can override bg/color/borderColor,
// and any extra Chakra props (e.g. `gap` for icon+text pills) pass through.
const MetaPill = React.forwardRef(
  (
    {children, bg, color, borderColor, ...rest}: Record<string, any>,
    ref: any,
  ) => {
    const defaultBg = useColorModeValue('gray.100', 'whiteAlpha.200');
    const defaultColor = useColorModeValue('gray.700', 'gray.300');
    const defaultBorderColor = useColorModeValue('gray.200', 'whiteAlpha.300');

    return (
      <Text
        ref={ref}
        as="span"
        display="inline-flex"
        alignItems="center"
        bg={bg ?? defaultBg}
        color={color ?? defaultColor}
        borderWidth="1px"
        borderColor={borderColor ?? defaultBorderColor}
        borderRadius="full"
        px={2}
        py={0.5}
        fontSize="xs"
        fontWeight="normal"
        lineHeight="1.3"
        maxW="100%"
        whiteSpace="nowrap"
        overflow="hidden"
        textOverflow="ellipsis"
        {...rest}
      >
        {children}
      </Text>
    );
  },
);

MetaPill.displayName = 'MetaPill';

export default MetaPill;
